import React from 'react';
import { TouchTargetProps } from 'apps/sigma2-ui/src/components/ui/TouchTarget';
import { TertiaryButton } from 'apps/sigma2-ui/src/components/TertiaryButton';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';

type EditRubricCancelButtonProps = Pick<TouchTargetProps, 'behavior'>;

const EditRubricCancelButtonIcon: React.FC<SvgProps> = (props) => {
  const fillColor = toSvgColor('currentColor', props);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1ZM8 3C5.23858 3 3 5.23858 3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8C13 5.23858 10.7614 3 8 3ZM9.29297 5.29297C9.68349 4.90244 10.3165 4.90244 10.707 5.29297C11.0976 5.68349 11.0976 6.31651 10.707 6.70703L9.41406 8L10.707 9.29297C11.0976 9.68349 11.0976 10.3165 10.707 10.707C10.3165 11.0976 9.68349 11.0976 9.29297 10.707L8 9.41406L6.70703 10.707C6.31651 11.0976 5.68349 11.0976 5.29297 10.707C4.90244 10.3165 4.90244 9.68349 5.29297 9.29297L6.58594 8L5.29297 6.70703C4.90244 6.31651 4.90244 5.68349 5.29297 5.29297C5.68349 4.90244 6.31651 4.90244 6.70703 5.29297L8 6.58594L9.29297 5.29297Z"
        fill={fillColor}
      />
    </svg>
  );
};

export const EditRubricCancelButton: React.FC<EditRubricCancelButtonProps> = ({
  behavior,
}) => {
  const language = useLanguage();
  return (
    <TertiaryButton
      label={language.editRubricCancelButtonLabel()}
      icon={<EditRubricCancelButtonIcon />}
      behavior={behavior}
      className="rounded border-[1.5px] border-royal-900 pl-4 pr-6 py-2"
    />
  );
};
